import styles from './ParentCommunicationSection.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ParentCommunicationCard from '../../components/ParentCommunicationCard/ParentCommunicationCard';

import { CiMemoPad } from 'react-icons/ci';
import { LuAlarmClock } from 'react-icons/lu';
import { RiFileList2Line } from 'react-icons/ri';
import { LuCalendarDays } from 'react-icons/lu';
import { useNavigate } from 'react-router';

const ParentCommunicationSection = () => {
  const navigate = useNavigate();
  const cardData = [
    {
      icon: <LuAlarmClock />,
      label: 'Concerns',
      leftCount: 0,
      rightCount: 0,
      leftLabel: 'pending',
      rightLabel: 'Reported Today',
      themeColorVar: '--Warning_Color',
      onClick: () => navigate(''),
    },
    {
      icon: <RiFileList2Line />,
      label: 'Notes',
      leftCount: 0,
      rightCount: 0,
      leftLabel: 'pending',
      rightLabel: 'Created Today',
      themeColorVar: '--Success_Color',
      onClick: () => navigate(''),
    },
    {
      icon: <LuCalendarDays />,
      label: 'Leaves',
      leftCount: 0,
      rightCount: 0,
      leftLabel: 'pending',
      rightLabel: 'Applied Today',
      themeColorVar: '--Primary_Color',
      onClick: () => navigate('attendance/studentleaves'),
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<CiMemoPad />} heading="Parent communication" />
      </div>

      <div className={styles.cards}>
        {cardData.map((item, index) => (
          <ParentCommunicationCard key={index} {...item} />
        ))}
      </div>
    </div>
  );
};

export default ParentCommunicationSection;
